import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSeo } from '../utils/seo';
import { PermutaForm } from '../components/forms/PermutaForm';
export function Permutas() {
  const [params] = useSearchParams();
  useSeo('Permutas | VCARS toma tu usado en parte de pago', 'Evaluamos tu vehículo y te ayudamos a usarlo como parte de pago para tu próxima compra.');
  return <main className="bg-ink" data-id="element-505" data-mp="p7uu4ppio5vu">
      <div className="border-b border-line bg-surface" data-id="element-506" data-mp="p6jpyos5sw47">
        <div className="mx-auto w-full max-w-7xl px-5 py-14 md:px-8 md:py-20" data-id="element-507" data-mp="u663z0ftage2">
          <h1 className="max-w-3xl text-4xl font-black leading-[1.05] tracking-tight text-white md:text-[52px]" data-id="element-508" data-mp="u4347ooux8w5">
            Tomamos tu usado en parte de pago
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-mist md:text-lg" data-id="element-509" data-mp="13vfuibv0br02">
            Si querés cambiar tu auto, evaluamos tu vehículo y te ayudamos a usarlo como
            parte de pago para tu próxima compra.
          </p>
        </div>
      </div>
      <section className="mx-auto w-full max-w-4xl px-5 py-16 md:px-8" data-id="element-510" data-mp="5edol5sgf9so">
        <PermutaForm vehiculoInteres={params.get('vehiculo') ?? ''} data-id="element-511" data-mp="1cs694x5i3b3" />
      </section>
    </main>;
}